import * as React from 'react';
import * as ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';

import styled, { tstyled } from '../theme';
import { FooterRenderer, IRenderProps } from '../models/Footer';
import DiscoDudeFooter from '../assets/disco-dude-footer.svg';

interface IProps {
  peach?: boolean;
}

const Container = tstyled<IProps>(styled.div)`
  background-color: ${(props) => (props.peach ? '#f0c491' : 'transparent')};
  padding: ${(props) => props.theme.mobilePadding}px;
  display: flex;
  justify-content: space-between;
  position: relative;

  a {
    color: ${(props) => props.theme.color.body2};
    text-decoration: underline;
    display: inline-block;
  }

  @media (min-width: ${(props) => props.theme.aboutBreakpoint}px) {
    display: none;
  }



  &::before {
    background-color: ${(props) =>
      props.peach ? props.theme.color.body2 : '#ebebeb'};
    content: '';
    height: 1px;
    display: block;
    width: 100%;
    position: absolute;
    top: 0;

    @media (max-width: ${(props) => props.theme.mobileBreakpoint - 1}px) {
      left: ${(props) => props.theme.mobilePadding}px;
      right: ${(props) => props.theme.mobilePadding}px;
      width: auto;
    }
  }
`;

const Column = styled.div`
  line-height: 1.5;
  font-size: 12px;
  color: ${(props) => props.theme.color.body2};
  width: 47%;

  > * {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const Social = styled.div`
  a {
    display: block;
  }
`;

const HomeLink = styled.div`
  a {
    display: block;
  }
`;

const ImageContainer = tstyled<IProps>(styled.div)`
  margin-top: 28px;
  width: 50px;
  padding-bottom: 31.5%;
  background-position: left top;
  background-repeat: no-repeat;
  background-blend-mode: multiply;
  background-color: ${(props) => (props.peach ? '#f0c491' : 'transparent')};
  background-size: contain;
`;

function Footer(props: IRenderProps & IProps) {
  const {
    data: { fields },
    peach,
  } = props;

  return (
    <Container peach={peach}>
      <Column>
        <ReactMarkdown
          source={fields.employmentStatus}
          renderers={{
            link: (p) => {
              if (!p.href.startsWith('http')) {
                return p.href;
              }

              return (
                <a
                  href={p.href}
                  rel="nofollow noreferrer noopener"
                  target="_blank"
                >
                  {p.children}
                </a>
              );
            },
          }}
        />
        <div>
          <div>
            <Link to="/about">About Troy Curtis Kreiner</Link>
          </div>
        </div>
        <div>{fields.currentLocation}</div>
        <HomeLink>
          <Link to="/egg">
            <ImageContainer
              peach={props.peach}
              style={{ backgroundImage: `url(${DiscoDudeFooter})` }}
            />
          </Link>
        </HomeLink>
      </Column>

      <Column>
        <div>
          {fields.emailTitle}
          <a href={`mailto:${fields.email}`}>{fields.email}</a>
        </div>
        <div>{fields.phoneNumber}</div>
        <Social>
          <a
            href={fields.facebook}
            rel="nofollow noreferrer noopener"
            target="_blank"
          >
            {/* 
              TODO: CMS model is coupled to specific social names. 
              To allow this to be more flexible in the future, these should
              be pulled from a relation list.
            */}
            Are.na
          </a>
          <a
            href={fields.instagram}
            rel="nofollow noreferrer noopener"
            target="_blank"
          >
            Instagram
          </a>
          <a
            href={fields.bluesky}
            rel="nofollow noreferrer noopener"
            target="_blank"
          >
            Bluesky
          </a>
          <br />
          <a
            href={fields.cv.fields.file.url}
            rel="nofollow noreferrer noopener"
            target="_blank"
          >
            Download CV
          </a>
        </Social>
      </Column>
    </Container>
  );
}

export default function Wrapper(props: IProps) {
  return <FooterRenderer render={Footer} {...props} />;
}



// WEBPACK FOOTER //
// ./src/components/FooterMobile.tsx